/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-pages-cms-note-legali',
    templateUrl: './note-legali.component.html',
})
export class PagesCmsNoteLegaliComponent { }
